export default "__VITE_ASSET__CRWclM6t__"